import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fontsource-variable/inter";
import { Amplify } from "aws-amplify";
import awsconfig from "./lib/aws-exports";
import { View } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css"; // default theme
import { Toaster } from "./components/ui/toaster";

Amplify.configure(awsconfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <View>
      <App />
      <Toaster />
    </View>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
